const URL_RE = /https?:\/\/\S+/gi;
const MARKDOWN_LINK_RE = /\[([^\]]+)\]\([^)]+\)/g;
const MARKDOWN_EMPHASIS_RE = /[*_#`]+/g;
const BULLET_LINE_RE = /^\s*[-*•]\s+/gm;

/** Prepare assistant text for browser TTS. */
export function sanitizeForSpeech(
  text: string,
  opts?: { maxSentences?: number }
): string {
  const maxSentences = opts?.maxSentences ?? 3;
  let t = text.replace(/\s+/g, ' ').trim();
  if (!t) return '';

  t = t.replace(MARKDOWN_LINK_RE, '$1');
  t = t.replace(URL_RE, '');
  t = t.replace(MARKDOWN_EMPHASIS_RE, '');
  t = t.replace(BULLET_LINE_RE, '');
  t = t.replace(/\s+/g, ' ').trim();

  const sentences = splitIntoSentences(t);
  if (maxSentences > 0 && sentences.length > maxSentences) {
    return sentences.slice(0, maxSentences).join(' ').trim();
  }
  return t;
}

/** Split text into speakable sentence chunks. */
export function splitIntoSentences(text: string): string[] {
  const t = text.replace(/\s+/g, ' ').trim();
  if (!t) return [];

  const parts: string[] = [];
  const re = /[^.!?]+[.!?]+|[^.!?]+$/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(t)) !== null) {
    const s = m[0].trim();
    if (s) parts.push(s);
  }
  return parts.length ? parts : [t];
}
